import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPhone = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M19.6 19.088c-.436.48-.928.839-1.492 1.07a4.5 4.5 0 0 1-1.75.342c-.896 0-1.835-.21-2.805-.624a14.6 14.6 0 0 1-2.85-1.64 23.5 23.5 0 0 1-2.682-2.289l-.003-.003a23 23 0 0 1-2.281-2.674l-.002-.002c-.673-.937-1.221-1.88-1.622-2.825v-.001c-.406-.962-.616-1.9-.616-2.81 0-.603.106-1.186.323-1.728a4.2 4.2 0 0 1 1.038-1.512C5.445 3.816 6.124 3.5 6.87 3.5c.293 0 .59.062.861.192.28.13.534.328.732.613l1.854 2.612c.16.224.285.44.374.658.09.212.151.447.151.681 0 .29-.084.568-.237.82-.13.23-.31.455-.522.666l-.593.616.003.023.015.034.002.005.024.06c.124.218.342.521.668.907q.528.613 1.134 1.236c.426.418.832.8 1.241 1.148.39.33.697.542.924.665l.059.026.006.003.04.018h.01l.596-.589h.002c.215-.216.443-.402.682-.53a1.56 1.56 0 0 1 .814-.232q.337 0 .677.141.326.137.652.361l.009.006 2.645 1.879c.271.188.48.424.61.72l.007.015c.099.246.164.51.164.81 0 .363-.08.732-.248 1.085-.156.33-.359.645-.626.939'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPhone)
export default ForwardRef
